import type { PortfolioReport } from '@ovComponents/5-page/portfolioTradingHub/types';
import {
  getPortfolioName,
  getTriggers,
} from '@ovComponents/5-page/portfolioTradingHub/utils';
import { useMemo } from 'react';
import type { PortfolioReason } from './types';

export const usePortfolioReasons = (
  selectedPortfolios: PortfolioReport[],
): Map<string, PortfolioReason> =>
  useMemo(
    () =>
      new Map(
        selectedPortfolios.map((portfolio) => {
          const triggers = getTriggers(portfolio);
          return [
            portfolio.id,
            {
              id: portfolio.id,
              name: getPortfolioName(portfolio),
              modelName: portfolio.modelPortfolio?.translatedName?.en || '',
              reason:
                triggers.length > 0
                  ? triggers.join(', ')
                  : 'Rebalance required',
            },
          ];
        }),
      ),
    [selectedPortfolios],
  );
